import get from '../helpers/get';

// eslint-disable-next-line import/prefer-default-export
export const isSoundMuted = state => get(state, ['audio', 'muted']);
